// ================== Light Colors ==================
import type { BaseColorsTypeOld } from '@zoomit/primitives';

const lightMainColors = {
  primary1: '#E4002B',
  primary2: '#E4002B',
  primary3: '#000000',
  error: '#E4002B',
  info: '#3D85B7',
  info2: '#3D85B7',
  success1: '#0FA862',
  success2: '#0FA862',
  warning1: '#FF9900',
  purple: '#FF9900',
};

const lightGreyColors = {
  grey1: '#7D7D87',
  grey3: '#AFAFB6',
  grey5: '#AFAFB6',
  grey6: '#EEEEEE',
  grey7: '#f9f9f9',
  black1: '#000000',
  black3: '#32323C',
  black5: '#eeeeee',
  white: '#FFFFFF',
};

const LightTextColors = {
  text: '#383E43',
  textGrey: lightGreyColors.grey1,
  textPrimary: lightMainColors.primary1,
  textHover: lightMainColors.primary1,
  textBlue: lightMainColors.info,
  textGreen: lightMainColors.success1,
  textOrange: lightMainColors.warning1,
  textWhite: lightGreyColors.white,
};

const LightBackgroundColors = {
  background1: lightGreyColors.grey7,
  background2: lightGreyColors.white,
  card: lightGreyColors.white,
  elevation: '#383E4330',
};

const LightBorderColors = {
  borderPrimary: '#EEEEEE',
  borderSecondary: '#AFAFB6',
};

export const LightColors: BaseColorsTypeOld = {
  ...lightMainColors,
  ...lightGreyColors,
  ...LightTextColors,
  ...LightBackgroundColors,
  ...LightBorderColors,
};

const DarkMainColors = {
  primary1: '#E4002B',
  primary2: '#FF6961',
  primary3: '#000000',
  error: '#FF6961',
  info: '#3D85B7',
  info2: '#3D85B7',
  success1: '#0FA862',
  success2: '#0FA862',
  warning1: '#FF9900',
  purple: '',
};

const DarkGreyColors = {
  grey1: '#EEEEEE',
  grey3: '#AFAFB6',
  grey5: '#7A7878',
  grey6: '#292C2D',
  grey7: '#383737',
  black1: '#000000',
  black3: '#AFAFB6',
  black5: '#4B4B55',
  white: '#FFFFFF',
};

const DarkTextColors = {
  text: '#E8E2D8',
  textGrey: DarkGreyColors.grey1,
  textPrimary: DarkMainColors.primary2,
  textHover: DarkMainColors.primary2,
  textBlue: DarkMainColors.info,
  textGreen: DarkMainColors.success1,
  textOrange: DarkMainColors.warning1,
  textWhite: '#E8E2D8',
};

const DarkBackgroundColors = {
  background1: '#202425',
  background2: '#1D1F20',
  card: '#292C2D',
  elevation: 'rgba(28,25,25,0.24)',
};

const DarkBorderColors = {
  borderPrimary: '#4B4B55',
  borderSecondary: '#7A7878',
};

export const DarkColors: BaseColorsTypeOld = {
  ...DarkMainColors,
  ...DarkGreyColors,
  ...DarkTextColors,
  ...DarkBackgroundColors,
  ...DarkBorderColors,
};
